import type { LabelFormattingInfo } from '@ardoq/data-model';
import { DragAndDropSectionsProvider } from '@ardoq/drag-and-drop';
import { LabelFormattingComponentViewModel } from '../../types';
import { LabelFormattingRulesHeaderHorizontal } from './LabelFormattingRulesHeaderHorizontal';
import { LabelFormattingComponent } from './LabelFormattingComponent';
import { LabelFormattingComponentHorizontal } from './LabelFormattingComponentHorizontal';

type LabelFormattingProperties = {
  labelFormatting: LabelFormattingInfo[];
  labelFormattingElementProps: LabelFormattingComponentViewModel[];
  onLabelFormattingReordered: (
    reorderedLabelFormatting: LabelFormattingInfo[]
  ) => void;
  onLabelFormattingDeleted: (index: number) => void;
  onUpdateLabelFormattingAt: (
    index: number,
    value: Partial<LabelFormattingInfo>
  ) => void;
  isHorizontal?: boolean;
};
const LabelFormatting = ({
  labelFormattingElementProps,
  labelFormatting,
  onLabelFormattingReordered,
  onLabelFormattingDeleted,
  onUpdateLabelFormattingAt,
  isHorizontal,
}: LabelFormattingProperties) => {
  if (!labelFormattingElementProps.length) {
    return null;
  }
  const labelFormattingIndexedById = Object.fromEntries(
    labelFormatting.map(labelFormatting => [
      labelFormatting.__id,
      labelFormatting,
    ])
  );
  const reorderLabelFormatting = (reorderedLabelFormattingIds: string[]) => {
    const reorderedLabelFormatting = reorderedLabelFormattingIds.map(
      id => labelFormattingIndexedById[id]
    );
    onLabelFormattingReordered(reorderedLabelFormatting);
  };
  const FormatComponent = isHorizontal
    ? LabelFormattingComponentHorizontal
    : LabelFormattingComponent;
  return (
    <>
      {isHorizontal && <LabelFormattingRulesHeaderHorizontal />}
      <DragAndDropSectionsProvider onDrop={reorderLabelFormatting}>
        {labelFormattingElementProps.map(labelFormattingProps => (
          <FormatComponent
            key={labelFormattingProps.labelFormatting.__id}
            onLabelFormattingDeleted={onLabelFormattingDeleted}
            onUpdateLabelFormattingAt={onUpdateLabelFormattingAt}
            {...labelFormattingProps}
            dragAndDropCardId={labelFormattingProps.labelFormatting.__id}
          />
        ))}
      </DragAndDropSectionsProvider>
    </>
  );
};

export { LabelFormatting };
